import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { getMasonryDriver } from '@leagueplatform/masonry';

const MasonryEnhancedMembersDisclaimerDriver = getMasonryDriver({
  rootNodeId: `benefits$enhancedBenefits$enhancedBenefitsDisclaimer`,
});

export const EnhancedMembersDisclaimer = () => (
  <MasonryEngine driver={MasonryEnhancedMembersDisclaimerDriver} />
);
